// extracted by mini-css-extract-plugin
module.exports = {"profileImage":"ProfilePicture_profileImage__3RbaT","profilePicture":"ProfilePicture_profilePicture__1JB3x","dummyImage":"ProfilePicture_dummyImage__KMMgg"};